import React, { useEffect } from 'react'
import PartnershipStyles from "./Contact.module.css"
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined'
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Button from '@mui/material/Button'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FilterListIcon from '@mui/icons-material/FilterList';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'
import { Co2Sharp } from '@mui/icons-material';

// ...
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    height: 523,
    bgcolor: 'white', // Update the background color to white
    border: '2px solid gray',
    // boxShadow: '2px 2px 10px 2px gray',
    borderRadius: '5px',
    p: 4,
};
// const modalRootStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     backgroundColor: 'transparent', // Set the background color outside the modal to fully transparent
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
// };

const modalContentStyle = {
    backgroundColor: 'white', // Set the background color of the modal content to white
    borderRadius: '5px',
    boxShadow: '2px 2px 10px 2px white',
    padding: '1rem',
};

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));


const rows = [];

const Contact = () => {
    const [jobRole, setJobRole] = React.useState("");
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const [entry,setEntry]=useState(0)
    const [filteredData, setFilteredData] = useState([])
    const [rowCount, setRowCount] = useState(10);
    const [query, setQuery] = useState("");

    const [selectedData, setSelectedData] = useState({})
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [view, setView] = useState(false)
    const handleView = (row) => {
        setView(true)
        // console.log(row)
        setSelectedData(row)

    }
    const handleViewClose = () => setView(false)



    const [data, setData] = useState([])

    const getApplicantData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/contactus/getAllContact`
            )
            setData(res.data)
            // console.error("helloss")
            // console.log(res.data)
            // console.log(res.data[0].jobrole[0].resume[0].userAppForm.applicantName)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getApplicantData();

    }, [])




  

    const handleJobRoles = (event) => {
        setJobRole(event.target.value);
        // console.log("hello"+event.target.value)
    };

    // const [open, setOpen] = useState(false);
    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);


    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const deleteContactbyId = async (contactId) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_STEELADMIN}/contactus/deleteContactFormById/${contactId}`
            )

            // this is the snipte for the notification
            dispatch(fetchNotifications())

            dispatch(setNotificationCount({
                count: count + 1,
            }))
            // console.log( res)
            dispatch(fetchNotifications())
            dispatch(setNotificationCount({
                count: count + 1,
            }))

            //   uptill here 

            alert('Delete Successful!')
            // window.location.reload()
            getApplicantData();
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(()=>{
        setEntry((prev)=>{
            return filteredData.length;
        })
    },[filteredData])
    useEffect(() => {
        console.log(jobRole)
        console.log(data)
        console.log("heesdaw")
        setFilteredData(data.filter(row => String(row.contactType).includes(jobRole)).reverse())
        
    }, [jobRole, data])

    useEffect(() => {
        setRowCount(filteredData.length)
        setPage(0);
    }, [data, query, filteredData])

    return (
        <>
            <Card sx={{ maxWidth: '95%', border: 'none', outline: 'none', boxShadow: 'none', mt: '3%' }}>
                <CardContent>
                    <Paper className={PartnershipStyles.myboder}>
                        <TableContainer sx={{ maxHeight: 650 }}>
                            <div className={PartnershipStyles.jobApplicantListBox1}>
                                <Box className={PartnershipStyles.Box1}>
                                    <Typography variant='h5' sx={{
                                        fontWeight: '500',
                                        fontSize: '20px',
                                        lineHeight: '24px',
                                        color: '#121926',
                                    }}>Contact submitted</Typography>
                                    <Typography variant='h6'>{entry} entries</Typography>
                                </Box>

                            </div>
                            <div className={PartnershipStyles.jobApplicantListBox2}>
                                <Box className={PartnershipStyles.Box1}>
                                    <Search>
                                        <SearchIconWrapper>
                                            <SearchIcon sx={{ zIndex: '1' }} />
                                        </SearchIconWrapper>
                                        <StyledInputBase
                                            placeholder="Search…"
                                            onChange={(e) => setQuery(e.target.value)}
                                            inputProps={{ 'aria-label': 'search' }}
                                            sx={{ width: '100%', color: '#121926', backgroundColor: '#F8FAFC', borderRadius: '10px', border: '1px solid #bdbdbd' }}
                                        />
                                    </Search>
                                </Box>
                                <Box className={PartnershipStyles.Box2}>
                                    Filter
                                    <FormControl sx={{ m: 1, width: '200px' }}>
                                        <Select
                                            value={jobRole}
                                            // filter={job.careerJobRoleName}
                                            onChange={handleJobRoles}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Without label" }}
                                            style={{ height: '5vh' }}
                                        >
                                            <MenuItem value="" >All Roles</MenuItem>
                                            <MenuItem value="Vendor" >Vendor</MenuItem>
                                            <MenuItem value='Customer'>Customer</MenuItem>
                                            <MenuItem value='Dealer'>Dealer</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div>
                            <Table stickyHeader aria-label="sticky table" sx={{ mt: '2%' }}>
                                <TableHead>
                                    <TableRow className={PartnershipStyles.Mainhead}>
                                        <TableCell className={PartnershipStyles.Tablehead}>User</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Phone number</TableCell>

                                        <TableCell className={PartnershipStyles.Tablehead}>Type</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Submitted on</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Message</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Ip Address</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {

                                        filteredData
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row) => {
                                                
                                                return (
                                                    <TableRow className={PartnershipStyles.MainRow} hover role="checkbox" tabIndex={-1} key={row.contactId} >
                                                        <TableCell className={PartnershipStyles.Tablerow1}> {row.contactName}<Box className={PartnershipStyles.Email}>{row.contactEmail}</Box></TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.contactNumber}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>{row.contactType} </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.contact_datetime}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.contactMessage.substr(0, 8) + '...'}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.contactIp}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            <VisibilityOutlinedIcon className={PartnershipStyles.Tableicon} style={{ marginRight: '10%' }} onClick={() => handleView(row)} />
                                                            <Modal
                                                                open={view}
                                                                onClose={handleViewClose}
                                                                aria-labelledby="modal-modal-title"
                                                                aria-describedby="modal-modal-description"
                                                                container={() => document.getElementById('modal-root')}
                                                                disablePortal

                                                                BackdropProps={{
                                                                    timeout: 500,
                                                                    style: { backgroundColor: '#454545',opacity:'30%' } 
                                                                  }}
                                                                  slotProps={{
                                                                    backdrop: {
                                                                      timeout: 500,
                                                                    },
                                                                  }
                                                        }

                                                            >
                                                                        <Box sx={style} className={PartnershipStyles.formStart} >
                                                                            <form action='' method=''>
                                                                                <label>Type</label>
                                                                                <Box className={PartnershipStyles.form}>
                                                                                    <input text='text' value={selectedData?.contactType} disabled></input>
                                                                                </Box>
                                                                                <label>Name</label>
                                                                                <Box className={PartnershipStyles.form}>
                                                                                    <input text='text' value={selectedData?.contactName} disabled></input>
                                                                                </Box>
                                                                                <label>Email</label>
                                                                                <Box className={PartnershipStyles.form}>
                                                                                    <input text='text' value={selectedData?.contactEmail} disabled></input>
                                                                                </Box>
                                                                                <label>Phone Number</label>
                                                                                <Box className={PartnershipStyles.form}>
                                                                                    <input text='text' value={selectedData?.contactNumber} disabled></input>
                                                                                </Box>
                                                                                <label>Message</label>
                                                                                <Box className={PartnershipStyles.form}>
                                                                                    <textarea text='text' col="10" rows="4" value={selectedData?.contactMessage} disabled></textarea>
                                                                                </Box>
                                                                            </form>
                                                                        </Box>
                                                            </Modal>
                                                            <DeleteForeverOutlinedIcon className={PartnershipStyles.Tableicon} onClick={() => deleteContactbyId(row.contactId)} />
                                                        </TableCell>
                                                        {/* <TableCell className={PartnershipStyles.Tablerow2}>
                                                            <Link
                                                               to={ `/applicants/${row?.resumeId}`}
                                                               state={{row:row}}
                                                            >
                                                               
                                                               
                                                                <VisibilityOutlinedIcon className={PartnershipStyles.Tableicon} />
                                                            </Link>
                                                            <Link disableRipple onClick={() => deleteApplicantbyId(row.resumeId)}>
                                                                <DeleteForeverOutlinedIcon style={{marginLeft:'10%'}} className={PartnershipStyles.Tableicon} />
                                                            </Link>
                                                        </TableCell> */}
                                                    </TableRow>
                                                );
                                            })

                                    }


                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={rowCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            style={{ paddingTop: '2%' }}

                        />
                    </Paper>
                </CardContent>
            </Card>
        </>
    )
}

export default Contact